<app-home-page-header [homePageHeader]="innovationHeader"></app-home-page-header>